import { SkeletonKpiRow, SkeletonTable } from "../../components/ui/Skeleton";

export function PortfolioSkeleton() {
	return (
		<div className="space-y-4">
			<SkeletonKpiRow count={4} />
			<SkeletonTable
				rows={4}
				cols={6}
				rowWidths={["w-2/3", "w-1/3", "w-1/2", "w-1/3", "w-1/4", "w-14"]}
			/>
		</div>
	);
}
